import { createApp } from 'vue'
import router from './router/index'
import { setupStore } from '@/store'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import directives from './directives'
import print from 'vue3-print-nb'
import App from './App.vue'
import i18n from './language/index.js'
import './permission'
import "./styles/index.scss";
import 'normalize.css'
import 'animate.css'
import './style.scss'

const app = createApp(App)

for(const [key, component] of Object.entries(ElementPlusIconsVue)){
  app.component(key, component)
}

app.use(router).use(setupStore).use(directives).use(print).use(i18n)
app.mount('#app')